// extracted by mini-css-extract-plugin
export default {"cls1":"Autocomplete-cls1_yqK","cls2":"Autocomplete-cls2_T1T Autocomplete-cls1_yqK"};